var _defs, _path, _path2, _path3, _path4, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllowancesNoTalking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "allowances-no-talking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.88,21.572a6,6,0,0,0,3.206.928H14A5.118,5.118,0,0,0,17.625,21h0a5.122,5.122,0,0,0,1.5-3.621V9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.125,9.75V4.5A1.5,1.5,0,0,0,8.625,3h0a1.5,1.5,0,0,0-1.5,1.5v9.75L4.686,12.3a1.539,1.539,0,0,0-2.242.348h0a1.537,1.537,0,0,0,0,1.707L3.876,16.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.125,5.25V3a1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5V4.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.125,4.5a1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5V6.75"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 22.125,
    y1: 3,
    x2: 1.875,
    y2: 22.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllowancesNoTalking);
export default __webpack_public_path__ + "static/media/allowances-no-talking.636de8e9.svg";
export { ForwardRef as ReactComponent };